// extracted by mini-css-extract-plugin
module.exports = {"left":"doctorRegister_left__293MS","left_tag":"doctorRegister_left_tag__1eQyH","left_desc":"doctorRegister_left_desc__21XiB","batch":"doctorRegister_batch__2_5KP"};